import { META_TWITTER_SITE } from "constants/config";

export function formatTweet(
  shareLabels: { [key: string]: string },
  url: string,
  takeaway?: string,
  summary?: string,
  answer?: string,
  query?: string
): string {
  const {
    "share-tweet-details-link": detailsLink,
    "share-tweet-details-takeaway": detailsTakeaway,
    "share-tweet-details-answer": detailsAnswer,
    "share-tweet-results-link": resultsLink,
    "share-tweet-results-summary": resultsSummary,
  } = shareLabels;

  let tweet = detailsLink;

  // Undefined means that the takeaway is not provided. "" means that the takeaway is disabled.
  if (takeaway) {
    tweet = detailsTakeaway.replace("{takeaway}", takeaway);
  } else if (answer) {
    tweet = detailsAnswer.replace("{answer}", answer);
  } else if (summary) {
    tweet = resultsSummary.replace("{summary}", summary);
  } else if (query) {
    tweet = resultsLink;
    tweet = tweet.replace("{query}", query || "");
  }

  return tweet
    .replace("{twitter-handle}", META_TWITTER_SITE)
    .replace("{url}", url);
}

export function formatCopyLinkText(
  shareLabels: { [key: string]: string },
  url: string,
  text?: string
): string {
  const { "share-copy-link-text": copyLinkText } = shareLabels;

  let copyText = "{url}";

  if (text !== undefined) {
    if (text === "") {
      return url;
    } else {
      copyText = copyLinkText.replace("{text}", text);
    }
  }
  return copyText.replace("{url}", url);
}
